export const CORE_MARKET_COUNTRY_IDS = [
  '5a08cc451b7ce3b929d4128b', // EE
  '5a08cc4d1b7ce3b929d41296', // FL
  '5a08cc4a1b7ce3b929d41291', // LT
  '5a08cc581b7ce3b929d412a0', // LV
];
